import { Component, OnInit } from '@angular/core';
import { combineLatest, filter, takeWhile } from 'rxjs';
import { BaseDetailsComponent } from 'kendo-angular-extensions';
import { FreeServicesParcelDetails } from './free-services-parcel-details.model';
import {
  FreeServicesParcelRequestGridDto,
  FspParcelDetailsAttributeDto,
} from '../free-services-parcel-request-grid/fsp-parcel-request-grid/free-services-parcel-request-grid-data-model';
import { FreeServicesParcelRequestGridDataService } from '../free-services-parcel-request-grid/fsp-parcel-request-grid/free-services-parcel-request-grid-data.service';
import { FspBorderPointsGridDataService } from '../free-services-parcel-request-grid/fsp-border-points-grid/fsp-border-points-grid-data.service';
import { FreeServicesRequestListGridDataService } from '../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { FreeServicesRequestListGridDto } from '../free-services-request-list-grid/free-services-request-list-grid-data-model';

@Component({
  selector: 'gk-free-services-parcel-details',
  templateUrl:
    '../../../../../../libs/kendo-angular-extensions/src/lib/base-details/base-details.component.html',
  standalone: false,
})
export class FreeServicesParcelDetailsComponent
  extends BaseDetailsComponent<FspParcelDetailsAttributeDto>
  implements OnInit
{
  override parseCallback = FreeServicesParcelDetails.fromApiToApp;

  constructor(
    private fspBorderPointsGridDataService: FspBorderPointsGridDataService,
    private freeServicesParcelRequestGridDataService: FreeServicesParcelRequestGridDataService,
    private freeServicesRequestListGridDataService: FreeServicesRequestListGridDataService,
  ) {
    super();
  }

  selectedParcelGridItem: FreeServicesParcelRequestGridDto;
  selectedRequestListGridItem: FreeServicesRequestListGridDto;

  ngOnInit(): void {
    this.subscribeToSelections();
  }

  private subscribeToSelections(): void {
    const parcelSelection$ =
      this.freeServicesParcelRequestGridDataService.$selection.pipe(
        takeWhile(() => this.isAlive),
        filter(Boolean),
      );

    const requestListSelection$ =
      this.freeServicesRequestListGridDataService.$selection.pipe(
        takeWhile(() => this.isAlive),
        filter(Boolean),
      );

    combineLatest([parcelSelection$, requestListSelection$]).subscribe(
      ([parcelSelection, requestListSelection]) => {
        this.selectedParcelGridItem = parcelSelection.selectedRows[0].dataItem;
        this.selectedRequestListGridItem =
          requestListSelection.selectedRows[0].dataItem;

        this.loadDataDetails();
      },
    );
  }

  private loadDataDetails(): void {
    if (!this.selectedParcelGridItem || !this.selectedRequestListGridItem)
      return;

    this.fspBorderPointsGridDataService.$loading.next(true);
    this.freeServicesParcelRequestGridDataService
      .fetchParcelDetailsFromApi(
        this.selectedRequestListGridItem.ZamowUuid,
        this.selectedParcelGridItem.KdzialkaUuid,
      )
      .subscribe((data) => {
        this.fspBorderPointsGridDataService.$loading.next(false);
        this.loadDetailsWithData(data);
      });
  }
}
